module.exports = __webpack_public_path__ + "img/stories.88e39cc7.png";